import { useState, useEffect, useRef } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useParams } from "react-router-dom";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { config, encodeBase64RequestBody, priceFormat, numberFormat, shortenUrl } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";
import io from 'socket.io-client';
import { format } from "date-fns";

const LeadEdit = () => {
  const { id_lead } = useParams();
  const [ leadData, setLeadData ] = useState(null);
  const [ companies, setCompanies ] = useState(null);
  const [ company, setCompany ] = useState(null);
  const [ subcompanies, setSubcompanies ] = useState(null);
  const [ subcompany, setSubcompany ] = useState(null);
  const [ users, setUsers ] = useState(null);
  const [ user, setUser ] = useState(null);
  const [ contacts, setContacts ] = useState(null);
  const [ contact, setContact ] = useState(null);
  const [ contactEmail, setContactEmail ] = useState('');
  const [ contactPhones, setContactPhones ] = useState([{ countryCode: '+62', number: '' }]);
  const [ contactPosition, setContactPosition ] = useState('');
  const [ contactFile, setContactFile ] = useState(null);
  const [ leadTranscript, setLeadTranscript ] = useState([]);
  const [ leadEnquiry, setLeadEnquiry ] = useState('');
  const [ leadCategory, setLeadCategory ] = useState(null);
  const [ leadProducts, setLeadProducts ] = useState('');
  const [ leadRegistration, setLeadRegistration ] = useState('');
  const [ leadRemarks, setLeadRemarks ] = useState('');
  const [ leadStatus, setLeadStatus ] = useState('');
  const [ bantBudget, setBantBudget ] = useState(1);
  const [ bantAuthority, setBantAuthority ] = useState('');
  const [ bantNeed, setBantNeed ] = useState('');
  const [ bantTimeline, setBantTimeline ] = useState('');
  const [ sourceName, setSourceName ] = useState('');
  const [ sourceChannel, setSourceChannel ] = useState(null);
  const [ sourceRemarks, setSourceRemarks ] = useState('');
  const [ sourceStatus, setSourceStatus ] = useState(null);
  const [ attachmentList, setAttachmentList ] = useState([]);
  const [ websiteForm, setWebsiteForm ] = useState(null);
  const [ isLoadingUpload, setIsLoadingUpload ] = useState(false);
  const [ isLoadingSummarize, setIsLoadingSummarize ] = useState(false);
  const [ isLoadingSubmit, setIsLoadingSubmit ] = useState(false);
  const [ isRecording, setIsRecording ] = useState(false);

  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  const socketRef = useRef(null);
  const mediaRecorderRef = useRef(null);

  const leadCategoryOptions = [
    { label: 'GWS SMB', value: 'GWS SMB' },
    { label: 'GWS CORP', value: 'GWS CORP' },
    { label: 'GWS ENTERPRISE', value: 'GWS ENTERPRISE' },
    { label: 'CHROME ENTERPRISE', value: 'CHROME ENTERPRISE' },
    { label: 'CHROME EDUCATION', value: 'CHROME EDUCATION' },
    { label: 'HARDWARE', value: 'HARDWARE' },
    { label: 'EDUCATION LICENSES', value: 'EDUCATION LICENSES' },
    { label: 'TRAINING', value: 'TRAINING' },
    { label: 'SERVICES', value: 'SERVICES' },
    { label: 'MICROSOFT', value: 'MICROSOFT' },
    { label: 'GOOGLE CLOUD', value: 'GOOGLE CLOUD' },
    { label: 'GEMINI ENTERPRISE', value: 'GEMINI ENTERPRISE' },
    { label: 'APIGEE', value: 'APIGEE' },
    { label: 'LUMAPPS', value: 'LUMAPPS' },
    { label: 'JUMPCLOUD', value: 'JUMPCLOUD' },
    { label: 'OTHER LICENSES', value: 'OTHER LICENSES' },
    { label: 'CUSTOM APPS', value: 'CUSTOM APPS' },
    { label: 'KAMIGAWE LICENSES', value: 'KAMIGAWE LICENSES' },
    { label: 'KAMIGAWE SERVICES', value: 'KAMIGAWE SERVICES' },
    { label: 'SAAS APPS (ALBAN)', value: 'SAAS APPS (ALBAN)' },
  ];

  const sourceNameOptions = [
    { value: 'Website', label: 'Website' },
    { value: 'Email', label: 'Email' },
    { value: 'Chat', label: 'Chat' },
    { value: 'Call', label: 'Call' },
    { value: 'Event', label: 'Event' },
    { value: 'Facebook', label: 'Facebook' },
    { value: 'LinkedIn', label: 'LinkedIn' },
    { value: 'Instagram', label: 'Instagram' },
    { value: 'Referral', label: 'Referral' },
    { value: 'WhatsApp', label: 'WhatsApp' },
  ];

  const sourceChannelOptions = [
    { value: 'Organic', label: 'Organic' },
    { value: 'Paid Search', label: 'Paid Search' },
  ];

  const sourceStatusOptions = [
    { value: 'Email Bounce', label: 'Email Bounce' },
    { value: 'Email Sent', label: 'Email Sent' },
    { value: 'Existing', label: 'Existing' },
    { value: 'WhatsApp Sent', label: 'WhatsApp Sent' },
  ];

  const phoneCodeOptions = [
    { code: '62', label: 'ID +62', value: '+62' },
    { code: '60', label: 'MY +60', value: '+60' },
    { code: '65', label: 'SG +65', value: '+65' },
    { code: '66', label: 'TH +66', value: '+66' },
    { code: '63', label: 'PH +63', value: '+63' },
    { code: '91', label: 'IN +91', value: '+91' },
    { code: '86', label: 'CN +86', value: '+86' },
    { code: '82', label: 'KR +82', value: '+82' },
    { code: '81', label: 'JP +81', value: '+81' },
    { code: '1', label: 'US +1', value: '+1' },
    { code: '44', label: 'GB +44', value: '+44' },
    { code: '84', label: 'VN +84', value: '+84' },
    { code: '61', label: 'AU +61', value: '+61' },
    { code: '49', label: 'DE +49', value: '+49' },
    { code: '33', label: 'FR +33', value: '+33' },
  ];

  useEffect(() => {
    const getLeadData = async () => {
      const fetchLead = await jwtFetch(config.ENDPOINT + 'get/lead', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          "id_lead": id_lead
        })
      });
      const responseLead = await fetchLead.json();
      if (responseLead.status === 200) {
        const lead = responseLead.data[0];
        if (!lead.contact_person_id && lead.website_form) {
          lead.website_form = JSON.parse(lead.website_form);
          setWebsiteForm(lead.website_form);
          setContact({ value: lead.contact_person_id || 0, label: lead.website_form.contact_name });
          setContactEmail(lead.website_form.contact_email || '');
          setContactPhones([{ countryCode: '+62', number: lead.website_form.contact_phone }]);
        } else {
          setContact({ value: lead.contact_person_id || 0, label: lead.contact_name });
          setContactEmail(lead.contact_email || '');
          if (lead.contact_phone) {
            const phoneNumbers = lead.contact_phone.split(',').map(phone => phone.trim()).filter(phone => phone !== '');
            const parsedPhones = phoneNumbers.map(phone => parsePhoneNumber(phone));
            setContactPhones(parsedPhones.length > 0 ? parsedPhones : [{ countryCode: '+62', number: '' }]);
          } else {
            setContactPhones([{ countryCode: '+62', number: '' }]);
          }
          setContactPosition(lead.contact_position || '');
        }
        setLeadData(lead);
        setCompany({ value: lead.company_id, label: lead.company_name });
        setSubcompany({ value: lead.subcompany_id, label: lead.subcompany_name });
        setLeadEnquiry(lead.lead_enquiry || '');
        setLeadCategory({ value: lead.lead_category, label: lead.lead_category });
        setLeadProducts(lead.lead_products || '');
        setLeadRegistration(lead.lead_registration || '');
        setLeadRemarks(lead.lead_remarks || '');
        setLeadStatus(lead.lead_status);
        setBantBudget(lead.bant_budget || '');
        setBantAuthority(lead.bant_authority || '');
        setBantNeed(lead.bant_need || '');
        setBantTimeline(lead.bant_timeline || '');
        setSourceName({ value: lead.source_name, label: lead.source_name });
        setSourceChannel({ value: lead.source_channel, label: lead.source_channel });
        setSourceStatus({ value: lead.source_status, label: lead.source_status });
        setUser({ value: lead.assigned_to, label: lead.sales_name });
        setSourceRemarks(lead.source_remarks || '');
        if (lead.attachment_files) {
          try {
            const leadAttachmentFiles = JSON.parse(lead.attachment_files);
            setAttachmentList(Array.isArray(leadAttachmentFiles) ? leadAttachmentFiles : []);
          } catch (error) {
            console.log('Error parsing attachment files:', error);
            setAttachmentList([]);
          }
        } else {
          setAttachmentList([]);
        }
      } else {
        console.log(responseLead.message);
      }
    };    
    getLeadData();
  }, [id_lead]);

  useEffect(() => {
    const socketUrl = config.BASEURL.replace(/\/$/, '');
    socketRef.current = io(socketUrl, {
      transports: ['websocket', 'polling'],
      timeout: 20000,
      forceNew: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5,
      maxReconnectionAttempts: 5
    });
    
    socketRef.current.on('connect', () => {
      console.log('Socket.IO connected successfully with ID:', socketRef.current.id);
    });
    
    socketRef.current.on('connect_error', (error) => {
      console.error('Socket.IO connection error:', error);
    });
    
    socketRef.current.on('disconnect', (reason) => {
      console.log('Socket.IO disconnected:', reason);
    });
    
    socketRef.current.on('transcript', (data) => {
      if (data && data.transcript && data.transcript.trim()) {
        if (data.isFinal) {
          setLeadTranscript(prevTranscript => [...prevTranscript, data.transcript.trim()]);
        }
      }
    });

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
      }
      if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
        mediaRecorderRef.current.stop();
      }
    };
  }, []);

  useEffect(() => {
    const getCompanies = async () => {
      try {
        const fetchCompanies = await jwtFetch(config.ENDPOINT + 'get/company', {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({})
        });
        const responseCompanies = await fetchCompanies.json();
        if (responseCompanies.status === 200) {
          const companies = [];
          for (let c in responseCompanies.data) {
            companies.push({
              value: responseCompanies.data[c].id_company,
              label: responseCompanies.data[c].company_name,
            });
          }
          setCompanies(companies);
        } else {
          console.log(responseCompanies.message);
        }
      } catch (error) {
        console.error('Error in getCompanies:', error);
        alert('An error occurred: ' + (error.message || error));
      }
    }
    getCompanies();

    const getUsers = async () => {
      try {
        const requestGetUsers = {
          "user_department": 'Sales',
          "user_level": 'User',
        }
        const fetchGetUsers = await jwtFetch(config.ENDPOINT + 'get/user', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestGetUsers)
        });
        const responseGetUsers = await fetchGetUsers.json();
        if (responseGetUsers.status === 200) {
          const usersOptions = responseGetUsers.data.map((user) => ({
            value: user.user_keyid,
            label: user.full_name
          }));
          setUsers(usersOptions);
        } else {
          alert(responseGetUsers.message);
        }
      } catch (error) {
        console.error('Error in getUsers:', error);
        alert('An error occurred: ' + (error.message || error));
      }
    };
    getUsers();
  }, []);

  useEffect(() => {
    if (company) {
      const getSubcompanies = async () => {
        try {
          const fetchSubcompanies = await jwtFetch(config.ENDPOINT + 'get/subcompany', {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
            },
            body: encodeBase64RequestBody({
              "company_id": company.value,
            })
          });
          const responseSubcompanies = await fetchSubcompanies.json();
          if (responseSubcompanies.status === 200) {
            const subcompanies = [];
            for (let s in responseSubcompanies.data) {
              subcompanies.push({
                value: responseSubcompanies.data[s].id_subcompany,
                label: responseSubcompanies.data[s].company_name,
              });
            }
            setSubcompanies(subcompanies);
          } else {
            console.log(responseSubcompanies.message);
          }
        } catch (error) {
          console.error('Error in getSubcompanies:', error);
          alert('An error occurred: ' + (error.message || error));
        }
      }
      getSubcompanies();
    }
  }, [company]);

  useEffect(() => {
    if (subcompany) {
      const getContacts = async () => {
        try {
          const fetchContacts = await jwtFetch(config.ENDPOINT + 'get/contact_person', {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
            },
            body: encodeBase64RequestBody({
              "company_id": company.value,
              "subcompany_id": subcompany.value,
            })
          });
          const responseContacts = await fetchContacts.json();
          if (responseContacts.status === 200) {
            const contacts = [];
            for (let c in responseContacts.data) {
              contacts.push({
                value: responseContacts.data[c].id_contact_person,
                label: responseContacts.data[c].cperson_name,
                email: responseContacts.data[c].cperson_email,
                phone: responseContacts.data[c].cperson_phone,
                position: responseContacts.data[c].cperson_position,
              });
            }
            setContacts(contacts);
          } else {
            console.log(responseContacts.message);
          }
        } catch (error) {
          console.error('Error in getContacts:', error);
          alert('An error occurred: ' + (error.message || error));
        }
      }
      getContacts();
    }
  }, [subcompany]);

  const parsePhoneNumber = (phone) => {
    const cleanPhone = phone.replace(/[^\d+]/g, '');
    for (const option of phoneCodeOptions) {
      if (cleanPhone.startsWith(option.code)) {
        return { countryCode: option.value, number: cleanPhone.substring(option.code.length) };
      }
    }
    return { countryCode: '+62', number: cleanPhone };
  };

  const changeContact = (value) => {
    setContact(value);
    setContactEmail(value.email || '');
    if (value.phone) {
      const phoneNumbers = value.phone.split(',').map(phone => phone.trim()).filter(phone => phone !== '');
      const phoneObjects = phoneNumbers.map(phone => parsePhoneNumber(phone));
      setContactPhones(phoneObjects.length > 0 ? phoneObjects : [{ countryCode: '+62', number: '' }]);
    } else {
      setContactPhones([{ countryCode: '+62', number: '' }]);
    }
    setContactPosition(value.position || '');
  }

  const uploadContact = async (e) => {
    e.preventDefault();
    setIsLoadingUpload(true);
    
    const file = contactFile[0];
    const formData = new FormData();
    formData.append('file', file);
    
    try {
      const fetchUploadContactFile = await jwtFetch(config.ENDPOINT + 'upload/lead', {
        method: 'POST',
        body: formData,
      });
      const responseUploadContactFile = await fetchUploadContactFile.json();
      if (responseUploadContactFile.status === 200) {
        let jsonData = responseUploadContactFile.data;
        jsonData = jsonData.replace(/```json\n/, '').replace(/\n```/, '');
        
        try {
          const contactCard = JSON.parse(jsonData);
          if (contactCard) {
            setContact({
              value: 0,
              label: contactCard.contact_name,
            });
            setContactEmail(contactCard.contact_email);
            // Handle multiple phone numbers separated by commas
            if (contactCard.contact_phone) {
              const phoneNumbers = contactCard.contact_phone.split(',').map(phone => phone.trim()).filter(phone => phone !== '');
              const phoneObjects = phoneNumbers.map(phone => parsePhoneNumber(phone));
              setContactPhones(phoneObjects.length > 0 ? phoneObjects : [{ countryCode: '+62', number: '' }]);
            } else {
              setContactPhones([{ countryCode: '+62', number: '' }]);
            }
            setContactPosition(contactCard.contact_position);
          }
          const fileInput = document.querySelector('input[type="file"]');
          if (fileInput) {
            fileInput.value = '';
          }
          setContactFile(null);
        } catch (parseError) {
          console.log('Error parsing contact data:', parseError);
        }
      } else {
        console.log(responseUploadContactFile.message);
      }
    } catch (error) {
      console.log('Error uploading file: ' + error.message);
    } finally {
      setIsLoadingUpload(false);
    }
  }

  const addAttachments = () => {
    const attachment = {
      name: '',
      files: '',
      loading: false
    };
    setAttachmentList([...attachmentList, attachment]);
  }

  const changeAttachmentData = (column, value, index) => {
    const attachment = attachmentList[index];
    attachment[column] = value;
    if (column === 'files') {
      attachment.loading = false;
    }
    setAttachmentList([...attachmentList]);
  }

  const uploadAttachments = async (files, index) => {
    changeAttachmentData('loading', true, index);
    const formData = new FormData();
    files.forEach((attachment) => {
      formData.append('files', attachment);
    });
    try {
      const responseUploadAttachments = await jwtFetch(config.ENDPOINT + 'upload/gdrive', {
        method: 'POST',
        body: formData,
      });
      if (!responseUploadAttachments.ok) {
        throw new Error(`Upload failed with status: ${responseUploadAttachments.status}`);
      }
      const resultUploadAttachments = await responseUploadAttachments.json();
      if (resultUploadAttachments.status === 200) {
        changeAttachmentData('files', resultUploadAttachments.data, index);
      } else {
        alert(`Upload error: ${resultUploadAttachments.message}`);
      }
    } catch (error) {
      alert(`Upload error: ${error.message || error}`);
    } finally {
      changeAttachmentData('loading', false, index);
    }
  }

  const removeAttachments = (index) => {
    attachmentList.splice(index, 1);
    setAttachmentList([...attachmentList]);
  }

  const startStopRecording = async () => {
    if (isRecording) {
      if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
        mediaRecorderRef.current.stop();
      }
      if (socketRef.current) {
        socketRef.current.emit('stop-stream');
      }
    } else {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        mediaRecorderRef.current = new MediaRecorder(stream, {
          mimeType: 'audio/webm;codecs=opus',
        });

        mediaRecorderRef.current.ondataavailable = (event) => {
          if (event.data.size > 0 && socketRef.current) {
            socketRef.current.emit('audio-stream', event.data);
          }
        };
        socketRef.current.emit('start-stream');
        mediaRecorderRef.current.start(500);        
      } catch (error) {
        console.error('Error accessing microphone:', error);
      }
    }
    setIsRecording(!isRecording);
  };

  const summarizeRecording = async () => {
    setIsLoadingSummarize(true);
    try {
      const requestSummarizeRecording = {
        "inputData": JSON.stringify(leadTranscript),
        "userKeyId": crmUser.user_keyid,
      };
      const fetchSummarizeRecording = await jwtFetch(config.ENDPOINT + 'summarize/lead', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestSummarizeRecording)
      });
      const responseSummarizeRecording = await fetchSummarizeRecording.json();
      if (responseSummarizeRecording.status === 200) {
        setLeadEnquiry(responseSummarizeRecording.data);
      } else {
        console.log(responseSummarizeRecording.message);
      }
    } catch (error) {
      console.log('Error summarizing recording: ' + error.message);
    }
    setIsLoadingSummarize(false);
  }

  const updateLead = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingSubmit(true);

      if (!contactEmail && !contactPhones.some(phone => phone.number.trim() !== '')) {
        alert('One of email or phone number is required.');
        document.querySelector('input[type="email"]').focus();
        setIsLoadingSubmit(false);
        return;
      }

      const requestLeadUpdate = {
        "id_lead": id_lead,
        "company_id": company.value,
        "subcompany_id": subcompany.value,
        "cperson_name": contact.label,
        "cperson_email": contactEmail,
        "cperson_phone": contactPhones.filter(phone => phone.number.trim() !== '').map(phone => phone.countryCode.replace('+', '') + phone.number).join(', '),
        "cperson_position": contactPosition,
        "lead_code": leadData.lead_code,
        "lead_enquiry": leadEnquiry,
        "lead_category": leadCategory.value,
        "lead_products": leadProducts,
        "lead_registration": leadRegistration,
        "lead_remarks": leadRemarks,
        "lead_status": leadStatus.value,
        "bant_budget": bantBudget,
        "bant_authority": bantAuthority,
        "bant_need": bantNeed,
        "bant_timeline": bantTimeline,
        "source_name": sourceName.value,
        "source_channel": sourceChannel.value,
        "source_status": sourceStatus.value,
        "source_remarks": sourceRemarks,
        "assigned_to": user.value,
        "attachment_files": attachmentList.length > 0 ? JSON.stringify(attachmentList) : null,
        "updated_on": format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
        "updated_by": crmUser.user_keyid,
      }

      const fetchLeadUpdate = await jwtFetch(config.ENDPOINT + 'update/lead', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestLeadUpdate)
      });
      const responseLeadUpdate = await fetchLeadUpdate.json();
      if (responseLeadUpdate.status === 200) {
        window.location.href = '/lead/detail/' + id_lead;
      } else {
        console.log(responseLeadUpdate.message);
        setIsLoadingSubmit(false);
      }
    } catch (error) {
      console.error('Error in updateLead:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  }

  return (
    <div id="lead-edit">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="lead"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center mb-3">
                    <a className="text-secondary" href="/lead">Lead List</a>
                    <span className="mx-3"><i className="bi bi-chevron-right"/></span>
                    <span>Lead Edit</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <div className="fs-24">Lead Edit</div>
                  </div>
                  <div className="row mb-4">
                    <div className="col-md-8">
                      <form className="bg-white border-radius-4 p-4" onSubmit={(e) => updateLead(e)} id="submit-form">
                        <div className="border border-1 border-radius-3 p-4 mb-3">
                          <div className="row form-group align-items-center mb-2">
                            <div className="col-md-4">
                              <label>Company Group <span className="text-danger">*</span></label>
                            </div>
                            <div className="col-md-8">
                              <Select options={companies} value={company} onChange={(value) => setCompany(value)} required/>
                            </div>
                          </div>
                          <div className="row form-group align-items-center mb-4">
                            <div className="col-md-4">
                              <label>Subsidiary <span className="text-danger">*</span></label>
                            </div>
                            <div className="col-md-8">
                              <Select options={subcompanies} value={subcompany} onChange={(value) => setSubcompany(value)} isDisabled={!company} required/>
                            </div>
                          </div>
                          {subcompany && (
                            <div>
                              <div className="row form-group align-items-center mb-2">
                                <div className="col-md-4">
                                  <label>Contact Person <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-8">
                                  <CreatableSelect options={contacts} value={contact} placeholder="Type name..." onCreateOption={(label) => changeContact({ value: 0, label: label })} onChange={(value) => changeContact(value)} isClearable required/>
                                </div>
                              </div>
                              <div className="row form-group align-items-center mb-2">
                                <div className="col-md-4">
                                  <label>Email <i className="bi bi-info-circle text-secondary" title="One of email or phone is required"></i></label>
                                </div>
                                <div className="col-md-8">
                                  <input className="form-control" type="email" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)}/>
                                </div>
                              </div>
                              <div className="row form-group align-items-baseline mb-4">
                                <div className="col-md-4">
                                  <label>Phone <i className="bi bi-info-circle text-secondary" title="One of phone or email is required"></i></label>
                                </div>
                                <div className="col-md-8">
                                  {contactPhones.map((phone, index) => (
                                    <div key={index} className="d-flex align-items-center mb-2">
                                      <select 
                                        className="form-select me-2" 
                                        style={{width: '120px'}}
                                        value={phone.countryCode} 
                                        onChange={(e) => {
                                          const newPhones = [...contactPhones];
                                          newPhones[index].countryCode = e.target.value;
                                          setContactPhones(newPhones);
                                        }}
                                      >
                                        {phoneCodeOptions.map((option) => (
                                          <option key={option.code} value={option.value}>
                                            {option.label}
                                          </option>
                                        ))}
                                      </select>
                                      <input 
                                        className="form-control me-2" 
                                        type="text" 
                                        placeholder="Phone number"
                                        value={phone.number} 
                                        onChange={(e) => {
                                          const newPhones = [...contactPhones];
                                          newPhones[index].number = e.target.value;
                                          setContactPhones(newPhones);
                                        }}
                                      />
                                      <button 
                                        type="button" 
                                        className="btn btn-danger btn-sm ms-2"
                                        onClick={() => {
                                          const newPhones = contactPhones.filter((_, i) => i !== index);
                                          setContactPhones(newPhones);
                                        }}
                                        disabled={contactPhones.length === 1}
                                      >
                                        <i className="bi bi-dash-circle"/>
                                      </button>
                                    </div>
                                  ))}
                                  <button 
                                    type="button" 
                                    className="btn btn-secondary btn-sm"
                                    onClick={() => setContactPhones([...contactPhones, { countryCode: '+62', number: '' }])}
                                  >
                                    <i className="bi bi-plus-lg me-1"/> Add
                                  </button>
                                </div>
                              </div>
                              <div className="row form-group align-items-center mb-4">
                                <div className="col-md-4">
                                  <label>Position</label>
                                </div>
                                <div className="col-md-8">
                                  <input className="form-control" type="text" value={contactPosition} onChange={(e) => setContactPosition(e.target.value)}/>
                                </div>
                              </div>

                              <div className="row form-group align-items-center mb-2">
                                <div className="col-md-4">
                                  <label>Enquiry <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-8">
                                  <textarea className="form-control" value={leadEnquiry} onChange={(e) => setLeadEnquiry(e.target.value)} required/>
                                </div>
                              </div>
                              <div className="row form-group align-items-center mb-2">
                                <div className="col-md-4">
                                  <label>Category <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-8">
                                  <Select options={leadCategoryOptions} value={leadCategory} placeholder="" onChange={(value) => setLeadCategory(value)} required/>
                                </div>
                              </div>
                              <div className="row form-group align-items-center mb-4">
                                <div className="col-md-4">
                                  <label>Products <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-8">
                                  <input className="form-control" type="text" value={leadProducts} onChange={(e) => setLeadProducts(e.target.value)} required/>
                                </div>
                              </div>
                              <div className="row form-group align-items-center mb-4">
                                <div className="col-md-4">
                                  <label>Deal Registration Number</label>
                                </div>
                                <div className="col-md-8">
                                  <input className="form-control" type="text" value={leadRegistration} onChange={(e) => setLeadRegistration(e.target.value)}/>
                                </div>
                              </div>
                              
                              <div className="row form-group align-items-center mb-2">
                                <div className="col-md-4">
                                  <label>Budget <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-8">
                                  <div className="input-group">
                                    <input className="form-control text-end" type="text" value={priceFormat(bantBudget)} onChange={(e) => setBantBudget(numberFormat(e.target.value))} required/>
                                    <span className="input-group-text mw-85">IDR</span>
                                  </div>
                                </div>
                              </div>
                              <div className="row form-group align-items-center mb-2">
                                <div className="col-md-4">
                                  <label>Authority <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-8">
                                  <textarea className="form-control" value={bantAuthority} onChange={(e) => setBantAuthority(e.target.value)}/>
                                </div>
                              </div>
                              <div className="row form-group align-items-center mb-2">
                                <div className="col-md-4">
                                  <label>Need <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-8">
                                  <textarea className="form-control" value={bantNeed} onChange={(e) => setBantNeed(e.target.value)}/>
                                </div>
                              </div>
                              <div className="row form-group align-items-center mb-4">
                                <div className="col-md-4">
                                  <label>Timeline <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-8">
                                  <textarea className="form-control" value={bantTimeline} onChange={(e) => setBantTimeline(e.target.value)}/>
                                </div>
                              </div>

                              <div className="row form-group align-items-center mb-4">
                                <div className="col-md-4">
                                  <label>Attachments</label>
                                </div>
                                <div className="col-md-8">
                                  <div className="table-responsive">
                                    <table className="table table-bordered mb-2">
                                      <thead>
                                        <tr>
                                          <th className="bg-secondary text-light" style={{textAlign: 'center'}}>#</th>
                                          <th className="bg-secondary text-light">File</th>
                                          <th className="bg-secondary text-light"></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {attachmentList && attachmentList.map((attachment, a) =>
                                          <tr key={"attachment-" + a}>
                                            <td valign="middle" align="center">{a + 1}</td>
                                            <td valign="middle">
                                              {attachment.loading === false ? (
                                                <div>
                                                  {attachment.files ? (
                                                    <a className="ellipsis" href={attachment.files[0].fileUrl} target="_blank" rel="noopener noreferrer">{shortenUrl(attachment.files[0].fileUrl, 50)} <i className="bi bi-link-45deg ms-2"/></a>
                                                  ) : (
                                                    <input className="form-control" type="file" accept=".pdf, .png, .jpg, .jpeg, .gif, .webp, .svg, .bmp, .avif, .csv, .xls, .xlsx" onChange={(e) => uploadAttachments(Array.from(e.target.files), a)} required />
                                                  )}
                                                </div>
                                              ) : 'Loading...'}
                                            </td>
                                            <td valign="middle" align="center">
                                              <button className="btn btn-sm btn-link text-danger" type="button" onClick={() => removeAttachments(a)}><i className="bi bi-trash"/></button>
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                    <div className="d-flex justify-content-start">
                                      <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => addAttachments()}><i className="bi bi-plus-lg me-2"/> Attachment</button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row form-group align-items-center mb-2">
                                <div className="col-md-4">
                                  <label>Source <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-8">
                                  <Select options={sourceNameOptions} value={sourceName} placeholder="" onChange={(value) => setSourceName(value)}/>
                                </div>
                              </div>
                              <div className="row form-group align-items-center mb-2">
                                <div className="col-md-4">
                                  <label>Channel</label>
                                </div>
                                <div className="col-md-8">
                                  <Select options={sourceChannelOptions} value={sourceChannel} placeholder="" onChange={(value) => setSourceChannel(value)} />
                                </div>
                              </div>                              
                              <div className="row form-group align-items-center mb-4">
                                <div className="col-md-4">
                                  <label>Follow Up</label>
                                </div>
                                <div className="col-md-8">
                                  <Select options={sourceStatusOptions} value={sourceStatus} placeholder="" onChange={(value) => setSourceStatus(value)} />
                                </div>
                              </div>

                              <div className="row form-group align-items-center mb-2">
                                <div className="col-md-4">
                                  <label>Assign To <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-md-8">
                                  <Select options={users} value={user} placeholder="" onChange={(value) => setUser(value)}/>
                                </div>
                              </div>
                              {crmUser.user_department === 'Marketing' && (
                                <div className="row form-group align-items-center mb-2">
                                  <div className="col-md-4">
                                    <label>Marketing Remarks</label>
                                  </div>
                                  <div className="col-md-8">
                                    <textarea className="form-control" value={sourceRemarks} onChange={(e) => setSourceRemarks(e.target.value)}/>
                                  </div>
                                </div>
                              )}
                              {crmUser.user_department === 'Sales' && (
                                <div className="row form-group align-items-center mb-2">
                                  <div className="col-md-4">
                                    <label>Sales Remarks</label>
                                  </div>
                                  <div className="col-md-8">
                                    <textarea className="form-control" value={leadRemarks} onChange={(e) => setLeadRemarks(e.target.value)}/>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        <div className="d-flex justify-content-end">
                          <button className="btn btn-link" type="button" onClick={() => window.location.href = `/lead/detail/${id_lead}`}>Cancel</button>
                          <button className="btn bg-gold ms-2" type="submit">{isLoadingSubmit ? 'Loading...' : 'Save'}</button>
                        </div>
                      </form>
                    </div>
                    
                    {(subcompany || websiteForm) && (
                      <div className="col-md-4">
                        {websiteForm && (
                          <div className="card mb-4">
                            <div className="card-body">
                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <p className="fs-14 mb-0"><strong>Enquiry Form</strong></p>
                              </div>
                              <div className="p-2">
                                <div className="row mb-2">
                                  <div className="col-md-4 text-secondary">Company</div>
                                  <div className="col-md-8">{websiteForm.company_name}</div>
                                </div>
                                <div className="row mb-2">
                                  <div className="col-md-4 text-secondary">Contact</div>
                                  <div className="col-md-8">{websiteForm.contact_name}</div>
                                </div>
                                <div className="row mb-2">
                                  <div className="col-md-4 text-secondary">Email</div>
                                  <div className="col-md-8">{websiteForm.contact_email}</div>
                                </div>
                                <div className="row">
                                  <div className="col-md-4 text-secondary">Phone</div>
                                  <div className="col-md-8">{websiteForm.contact_phone}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="card mb-4">
                          <div className="card-body border-0">
                            <form onSubmit={(e) => uploadContact(e)}>
                              <div className="fs-18 mb-3">Name Card Reader</div>
                              <input className="form-control mb-2" type="file" accept=".pdf, .png, .jpg, .jpeg, .gif, .webp, .svg, .bmp, .avif, .csv, .xls, .xlsx" onChange={(e) => setContactFile(Array.from(e.target.files))} required/>
                              <div className="d-flex justify-content-end">
                                <button className="btn bg-gold ms-2" type="submit" disabled={isLoadingUpload}>{isLoadingUpload ? "Loading..." : (<span><i className="bi bi-stars me-1"/> Read Card</span>)}</button>
                              </div>
                            </form>
                          </div>
                        </div>
                        
                        <div className="card mb-4">
                          <div className="card-body border-0">
                            <div className="fs-18 mb-3">Voice Reader</div>
                            <div>
                              {leadTranscript.length > 0 ? (
                                <div className="record-box mb-2">
                                  {leadTranscript.map((sentence, index) => (
                                    <p className="mb-1" key={index}>{sentence}</p>
                                  ))}
                                </div>
                              ) : (
                                <p>Click 'Record' and start speaking...</p>
                              )}
                            </div>
                            <div className="d-flex justify-content-end">
                              <button className={"btn ms-2 " + (isRecording ? 'bg-danger text-light' : 'bg-gold')} type="button" onClick={startStopRecording}>{isRecording ? (<span><i className="bi bi-square-fill me-1"/> Stop</span>) : (<span><i className="bi bi-square me-1"/> Record</span>)}</button>
                              {leadTranscript.length > 0 && (
                                <button className="btn bg-gold ms-2" type="button" onClick={() => summarizeRecording()} disabled={isLoadingSummarize}>{isLoadingSummarize ? "Loading..." : (<span><i className="bi bi-stars me-1"/> Summarize</span>)}</button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    
                  </div>
                </section>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadEdit;


